import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    localeItem: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    dialogButtons: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    localeTranslationsContainer: {
        flexDirection: "column",
        flexShrink: 1,
        width: "100%"
    },
    translationRow: {
        alignItems: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: 200
    },
    localeInfoContainer: {
        flexDirection: "column",
        flexShrink: 1
    },
    deleteKeyBadge: {
        alignSelf: "flex-start"
    },
    dialogContentContainer: {
        alignItems: "stretch",
        width: "100%"
    },
    headerTitleContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    systemBadgeContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    localeKeyContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    actionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        width: "100%"
    },
    localeItemWrapper: {
        width: "100%"
    },
    filtersContainer: {
        width: "100%"
    },
    listContainer: {
        width: "100%"
    },
    dialogForm: {
        width: "100%"
    },
    container: {
        width: "100%"
    }
});
export default stylesheet;
